import { render, staticRenderFns } from "./ChatModal.vue?vue&type=template&id=11fcc0e3&scoped=true"
import script from "./ChatModal.vue?vue&type=script&lang=js"
export * from "./ChatModal.vue?vue&type=script&lang=js"
import style0 from "./ChatModal.vue?vue&type=style&index=0&id=11fcc0e3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fcc0e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11fcc0e3')) {
      api.createRecord('11fcc0e3', component.options)
    } else {
      api.reload('11fcc0e3', component.options)
    }
    module.hot.accept("./ChatModal.vue?vue&type=template&id=11fcc0e3&scoped=true", function () {
      api.rerender('11fcc0e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/message/ChatModal.vue"
export default component.exports